<script setup lang="ts">
import { computed } from 'vue';
import {
  trackerPickerDeviceId,
  trackerPickerDeviceImei,
  trackerPickerDeviceSerial,
} from '@gpx-spa/ui';
import {
  namedTrackerLabel,
  type NamedTracker,
} from '@/utils/named-tracker-set';

const props = defineProps<{
  trackers: NamedTracker[];
}>();

const rows = computed(() =>
  props.trackers.map((tracker) => ({
    tracker,
    label: namedTrackerLabel(tracker),
    serial: trackerPickerDeviceSerial({
      id: tracker.id,
      serial: tracker.serial ?? undefined,
    }),
    imei: trackerPickerDeviceImei({
      id: tracker.id,
      imei: tracker.imei ?? undefined,
    }),
    idLabel: trackerPickerDeviceId({ id: tracker.id }),
  })),
);
</script>

<template>
  <ul class="w-[min(22rem,85vw)] overflow-hidden rounded-md">
    <li
      v-for="row in rows"
      :key="row.tracker.id"
      class="flex items-center gap-3 border-b border-gray-100 px-3 py-2 last:border-b-0"
    >
      <div
        class="flex size-8 shrink-0 items-center justify-center rounded-full bg-gray-100"
      >
        <i class="pi pi-wifi text-sm text-gray-400" aria-hidden="true" />
      </div>
      <div class="min-w-0 flex-1">
        <p class="truncate text-sm font-medium text-gray-900">
          {{ row.label }}
        </p>
        <p class="truncate font-mono text-xs text-gpx_gray-200">
          Serial:
          {{ row.serial }}
          <span class="mx-1.5 opacity-50" aria-hidden="true">·</span>
          IMEI:
          {{ row.imei }}
          <span class="mx-1.5 opacity-50" aria-hidden="true">·</span>
          ID:
          {{ row.idLabel }}
        </p>
      </div>
    </li>
  </ul>
</template>
